export const getThemeClasses = (isDarkMode: boolean) => ({
  bg: isDarkMode ? "bg-dark-surface" : "bg-white",
  border: isDarkMode ? "border-dark-border" : "border-gray-200",
  text: isDarkMode ? "text-white" : "text-gray-900",
  textSecondary: isDarkMode ? "text-gray-400" : "text-gray-600",
  cardBg: isDarkMode ? "bg-dark-card" : "bg-white",
  cardBorder: isDarkMode ? "border-dark-border" : "border-gray-200",
  buttonHover: isDarkMode ? "hover:bg-[#2E2E2E]" : "hover:bg-gray-100",
  buttonText: isDarkMode ? "text-gray-400" : "text-gray-600",
  buttonTextHover: isDarkMode ? "hover:text-white" : "hover:text-gray-900",
  input: isDarkMode ? "bg-dark-card" : "bg-gray-50",
});

export type ThemeClasses = ReturnType<typeof getThemeClasses>;